module.exports = __webpack_public_path__ + "img/tv.d141234.svg";